import { Container, TextField, Button, Box, Paper, Typography, Input, Checkbox, FormControlLabel } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import * as endPoints from '../assets/js/endpoints';
import Loader from '../components/loader';
import { useEffect, useState } from 'react';
import { useNotification } from '../assets/contexts/notificationContext';
import { Helmet } from 'react-helmet';

const CreateService = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [form, setForm] = useState({
    name: '',
    description: '',
    price: '',
    hora_inicio: '',
    hora_fin: '',
    duration: '',
    color: '#000000',
    active: true,
  });

  useEffect(() => {
    if (id) {
      setLoading(true);
      endPoints.getService(id)
        .then(data => {
          setForm({
            name: data.name || '',
            description: data.description || '',
            price: data.price || '',
            hora_inicio: data.hora_inicio || '',
            hora_fin: data.hora_fin || '',
            duration: data.duration || '',
            color: data.color || '#000000',
            active: data.active !== false,
          });
          setImage(null);
        })
        .catch(err => {
          showNotification('Error cargando servicio', 'error');
        })
        .finally(() => setLoading(false));
    }
  }, [id]);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });
  const handleImageChange = e => {
    if (e.target.files && e.target.files[0]) setImage(e.target.files[0]);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = { ...form };
      if (image) data.image = image;
      if (id) {
        await endPoints.updateService(id, data);
        showNotification('Servicio actualizado', 'success');
      } else {
        await endPoints.createService(data);
        showNotification('Servicio creado', 'success');
      }
      navigate('/admin/manageServices');
    } catch (err) {
      const msg = err.response?.data?.error || 'Error guardando servicio';
      showNotification(msg, 'error');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loader />;

  return (
    <>
      <Helmet>
        <title>{id ? 'Actualizar Servicio' : 'Crear Servicio'} | CES</title>
      </Helmet>
      <Container sx={{ mt:5, pb:2, mb:2 }}>
        <Paper sx={{ p: 3, maxWidth: 800, mx: 'auto',}}>
          <Typography variant='h5' gutterBottom>
            {id ? 'Actualizar Servicio' : 'Crear Servicio'}
          </Typography>
          <Box component='form' onSubmit={handleSubmit}  sx={{
          display: 'grid',
          gap: 2,
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
          maxWidth: 750,
          mx: 'auto',
          mb: 2,
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <TextField label='Nombre' name='name' value={form.name} onChange={handleChange} required />         
          <TextField label='Precio' name='price' type='number' value={form.price} onChange={handleChange} />
          <TextField label='Hora Inicio' name='hora_inicio' type='time' value={form.hora_inicio} onChange={handleChange} />
          <TextField label='Hora Fin' name='hora_fin' type='time' value={form.hora_fin} onChange={handleChange} />
          <TextField label='Duración (min)' name='duration' type='number' value={form.duration} onChange={handleChange} />
          <TextField type='color' label='Color' name='color' value={form.color} onChange={handleChange} InputLabelProps={{ shrink: true }} />
          <FormControlLabel
            control={<Checkbox name='active' checked={Boolean(form.active)} onChange={e => setForm(prev => ({ ...prev, active: e.target.checked }))} />}
            label='Activo (visible en Pide tu cita)'
          />
          <Input type='file' accept='image/*' onChange={handleImageChange} sx={{ gridColumn: '1 / -1' }} />
           <TextField label='Descripción' name='description' value={form.description} onChange={handleChange} multiline rows={3} sx={{gridColumn: '1 / -1'}} />
             <Box  sx={{
                gridColumn: '1 / -1',       // abarca desde la columna 1 hasta la última
                display: 'flex',            // usa flexbox para centrar
                justifyContent: 'center',   // centra horizontalmente
              }}>
             <Button type='submit' variant='contained' sx={{ display: 'block', mx: 'auto',  }}>
            {id ? 'Actualizar' : 'Crear'} Servicio
          </Button>
          </Box>
          </Box>
        </Paper>
      </Container>
    </>
  );
};

export default CreateService;
